import styled from 'styled-components';
import { palette } from '../../../theme/colors';

export const SContainer = styled.div<{ $borderColor: string }>`
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  min-width: 5rem;
  margin: 0 0.625rem 1.5rem;
  padding: 0.75rem 0.625rem;
  background-color: ${palette.cloudBurst};
  border: 2px solid ${({ $borderColor }) => $borderColor};
  border-radius: 0.75rem;
  overflow: hidden;
`;

export const SContent = styled.div`
  padding: 0 0.75rem;
  gap: 0.625rem;
  display: flex;
  flex-direction: column;
`;

export const SRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 0.125rem;
  gap: 0.25rem;
`;

export const SLabel = styled.span`
  font-family: 'Roboto-Regular';
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: ${palette.navy20};
`;

export const SBoldValue = styled.span`
  flex-shrink: 1;
  font-family: 'Roboto-Bold';
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: ${palette.white};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SAlarmName = styled.p<{ $color: string }>`
  margin: 0;
  font-family: 'Roboto-Bold';
  font-size: 1.25rem;
  line-height: 1.625rem;
  text-transform: uppercase;
  color: ${({ $color }) => $color};
`;

export const SOrganizationName = styled.p`
  flex: 1;
  min-width: 0;
  margin: 0.25rem 0 0;
  font-family: 'Roboto-Regular';
  font-size: 0.875rem;
  line-height: 1.125rem;
  overflow-wrap: anywhere;
  color: ${palette.navy20};
`;

export const SSentTimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  gap: 0.625rem;
`;

export const SSentTime = styled.span`
  align-self: flex-end;
  flex-shrink: 0;
  font-family: 'Roboto-Regular';
  font-size: 0.75rem;
  line-height: 1rem;
  color: ${palette.navy20};
`;

export const SSeparator = styled.div`
  height: 1px;
  background-color: ${palette.navy40};
`;

export const SSectionContainer = styled.div`
  margin: 0 0.75rem;
`;

export const SSectionTitle = styled.p<{ $color: string }>`
  margin: 0 0 0.25rem;
  font-family: 'Roboto-Medium';
  font-size: 0.75rem;
  line-height: 0.9375rem;
  text-transform: uppercase;
  color: ${({ $color }) => $color};
`;

export const SSectionText = styled.p`
  flex: 1;
  min-width: 0;
  margin: 0;
  font-family: 'Roboto-Regular';
  font-size: 1rem;
  line-height: 1.3rem;
  color: ${palette.white};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;
